// Exit-попап с гайдом по питанию.
//
// Десктоп (мышь): курсор ушёл за верхний край окна.
// Тач-устройства: пролистал тарифы и не выбрал план, либо вернулся во вкладку.
// Кнопку «назад» не перехватываем — это запрещают правила Google Search и Google Ads.
//
// Показываем не чаще раза за сессию, никогда после получения гайда
// и никогда после клика на тариф или квиз.
// Для проверки: ?lead-popup в адресе открывает попап сразу, без условий.

const SHOWN_KEY = 'vfitLeadShown';   // sessionStorage: уже показывали в этой сессии
const DONE_KEY = 'vfitLeadDone';     // localStorage: гайд получен
const BUYING_KEY = 'vfitLeadBuying'; // sessionStorage: кликнул на тариф или квиз

const ARM_DELAY = 10000;     // десктоп: первые 10 с на странице уход курсора не считается
const EXIT_DELAY = 300;      // десктоп: курсор должен не вернуться за это время
const SCROLL_IDLE = 1000;    // тач: попап после остановки прокрутки, а не на ходу
const ENGAGED_TIME = 20000;  // тач: столько провёл на странице до ухода из вкладки
const AWAY_TIME = 3000;      // тач: столько отсутствовал

function storageGet(type, key) {
  try {
    return window[type].getItem(key);
  } catch (e) {
    return null;
  }
}

function storageSet(type, key, value) {
  try {
    window[type].setItem(key, value);
  } catch (e) {
    // приватный режим или запрет хранилища — просто не запоминаем
  }
}

function track(event, trigger) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: event, lead_popup_trigger: trigger });
}

// Заголовок формы приходит из Kajabi простым текстом — последнее слово красим, как в макете
function accentLastWord(el) {
  if (!el) return;

  const words = el.textContent.trim().split(/\s+/);
  if (words.length < 2) return;

  const accent = document.createElement('span');
  accent.className = 'accent-purple';
  accent.textContent = words.pop();

  el.textContent = words.join(' ') + ' ';
  el.appendChild(accent);
}

export function leadPopup() {
  const popup = document.getElementById('lead-popup');

  if (!popup || typeof popup.showModal !== 'function') return;

  accentLastWord(popup.querySelector('.kajabi-form__title'));

  let trigger = '';

  function canShow() {
    return !popup.open
      && !storageGet('localStorage', DONE_KEY)
      && !storageGet('sessionStorage', SHOWN_KEY)
      && !storageGet('sessionStorage', BUYING_KEY)
      && !document.body.classList.contains('scroll-lock') // открыто мобильное меню
      && !document.documentElement.classList.contains('pum-open'); // открыт попап «Subscribe Free»
  }

  function open(source) {
    if (popup.open) return;

    trigger = source;
    storageSet('sessionStorage', SHOWN_KEY, '1');

    popup.showModal();
    document.body.classList.add('scroll-lock');
    track('lead_popup_shown', trigger);
  }

  function close() {
    popup.close();
  }

  popup.addEventListener('close', () => {
    document.body.classList.remove('scroll-lock');
  });

  // Клик по затемнению вокруг окна. Нажатие тоже должно начаться на затемнении —
  // иначе попап закроется, когда выделяешь текст в поле и отпускаешь мышь снаружи
  let pressedOnBackdrop = false;

  popup.addEventListener('pointerdown', (e) => {
    pressedOnBackdrop = e.target === popup;
  });

  popup.addEventListener('click', (e) => {
    if (e.target === popup && pressedOnBackdrop) close();
  });

  popup.querySelectorAll('[data-lead-popup-close]').forEach((btn) => {
    btn.addEventListener('click', close);
  });

  // Форма Kajabi отправлена (submit срабатывает после проверки обязательных полей браузером),
  // дальше Kajabi уводит на свою thank-you page. Запоминаем, чтобы попап больше не показывался
  popup.addEventListener('submit', () => {
    storageSet('localStorage', DONE_KEY, '1');
    track('lead_popup_submitted', trigger);
  });

  // Клик на тариф (чекаут Kajabi) или на квиз — человек уже покупает, гайд не предлагаем
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="mykajabi.com"], [data-checkout]');
    if (link && !popup.contains(link)) storageSet('sessionStorage', BUYING_KEY, '1');
  });

  if (new URLSearchParams(window.location.search).has('lead-popup')) {
    open('debug');
    return;
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    initExitIntent(canShow, open);
  } else {
    initTouchTriggers(canShow, open);
  }
}

// ─── Десктоп: курсор ушёл за верх окна ───────

function initExitIntent(canShow, open) {
  let armed = false;
  let timer = null;

  setTimeout(() => {
    armed = true;
  }, ARM_DELAY);

  document.addEventListener('mouseout', (e) => {
    // relatedTarget пуст, когда курсор покинул окно, clientY <= 0 — через верх
    if (!armed || e.relatedTarget || e.clientY > 0) return;

    clearTimeout(timer);
    timer = setTimeout(() => {
      if (document.visibilityState === 'visible' && canShow()) open('exit_intent');
    }, EXIT_DELAY);
  });

  // Вернулся в окно или ушёл на другую вкладку — отбой
  document.addEventListener('mouseover', () => clearTimeout(timer));
  document.addEventListener('visibilitychange', () => clearTimeout(timer));
}

// ─── Тач: тарифы позади или возврат во вкладку ─

function initTouchTriggers(canShow, open) {
  const plans = document.getElementById('plans');

  if (plans) {
    let idleTimer = null;

    window.addEventListener('scroll', () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        // Секция тарифов целиком ушла вверх за экран — в том числе после прыжка по меню
        const plansPassed = plans.getBoundingClientRect().bottom < 0;
        if (plansPassed && canShow()) open('plans_passed');
      }, SCROLL_IDLE);
    }, { passive: true });
  }

  const startedAt = Date.now();
  let hiddenAt = 0;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      return;
    }

    if (!hiddenAt) return;

    const engaged = hiddenAt - startedAt >= ENGAGED_TIME;
    const away = Date.now() - hiddenAt >= AWAY_TIME;

    if (engaged && away) {
      // даём странице отрисоваться после возврата
      setTimeout(() => {
        if (canShow()) open('tab_return');
      }, 400);
    }
  });
}
